import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router';
import { HomeService } from 'src/app/services/home.service';
import { Setting } from 'src/app/models/setting.model';
import { getLocalTranslate } from 'src/app/helpers/global-functions'

@Component({
  selector: 'app-page',
  templateUrl: './page.component.html',
  styleUrls: ['./page.component.css']
})
export class PageComponent implements OnInit {

  isLoggedIn = false
  isCheckedAuth = false
  isNotMyAccount = !this.router.url.includes('my-account');
  setting:Setting = new Setting()

  myAccount:string = 'My Account'
  login:string = 'Login'
  register:string = 'Register'
  contactSupport:string = 'Contact support'
  ourLocation:string = 'Our location'
  contactEmail:string = 'Contact email'

  flagImage:string = 'assets/img/us-flag.jpg'


  constructor(
    private authService: AuthService,
    private router: Router,
    private homeService:HomeService
  ) { }

  ngOnInit() {
    
    const defaultLanguage = localStorage.getItem('camedu-language')
    this.flagImage = defaultLanguage === 'EN' || undefined ? 'assets/img/kh-flag.png' : 'assets/img/us-flag.jpg'
    this.checkAuth()
    this.getSetting()
    this.getTranslate()
  }

  async checkAuth() {
    this.isCheckedAuth = false
    let isLoggedIn = await this.authService.checkAuth()
    this.isCheckedAuth = true
    this.isLoggedIn = isLoggedIn !== null
  }

  onActivate(event) {
    window.scroll(0, 0);
  }


  getSetting(){
    this.homeService.getSetting().then(result=>{
      this.setting = result as Setting
    })
  }

  getTranslate() {
    this.homeService.getTranslate().then(result => {
      localStorage.setItem('local-translate', JSON.stringify(result))
      this.myAccount = getLocalTranslate('my-account',this.myAccount)
      this.login = getLocalTranslate('login',this.login)
      this.register = getLocalTranslate('register',this.register)
      this.contactSupport = getLocalTranslate('contact-support',this.contactSupport)
      this.ourLocation = getLocalTranslate('our-location',this.ourLocation)
      this.contactEmail = getLocalTranslate('contact-email',this.contactEmail)
    })
  }

  onSwitchLanguage(){
    const defaultLanguage = localStorage.getItem('camedu-language')
    var currentLanguage:string = ''
    if(!defaultLanguage){
      currentLanguage = 'EN'
    }else{
      currentLanguage = defaultLanguage === 'EN' ? 'KH' : 'EN'
    }
    console.log(currentLanguage)
    localStorage.setItem('camedu-language', currentLanguage)
    window.location.reload()
  }


}
